import React, {useEffect, useRef} from 'react';
import {useJudgeMe} from '../../contexts/JudgeMeContext.client';

type Props = {
  productId: number;
  productTitle?: string;
  skipReload?: boolean;
};

const ProductReviews: React.FC<Props> = ({
  productId,
  productTitle,
  skipReload = false,
}) => {
  const {isLoaded, reload} = useJudgeMe();
  const widget = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // We put classNames on after we have mounted and judgeMe has loaded so that we can control
    // when to load the widget. Or else it becomes messy.
    if (
      isLoaded &&
      widget.current &&
      !widget.current.classList.contains('jdgm-widget')
    ) {
      widget.current.className =
        'jdgm-widget jdgm-review-widget jdgm-outside-widget';
      !skipReload && reload();
    }
  }, [isLoaded, reload, skipReload]);

  return (
    <div className={'px-4 sm:px-12'}>
      <div className="container mx-auto max-w-[60rem] py-20">
        <div
          ref={widget}
          data-id={productId}
          data-product-title={productTitle ?? ''}
        ></div>
      </div>
    </div>
  );
};

export default ProductReviews;
